import FlyoverUpsell2 from './FlyoverUpsell2';

export default FlyoverUpsell2;
